import { getCookie, setCookie } from '@/_shared/services/auth-cookies';

export function createUUID() {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = ((dt + Math.random() * 16) % 16) | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export function getUUID() {
  let sUId = getCookie('log_uid');
  if (!sUId) {
    sUId = setUUID();
  }
  return sUId;
}

export function setUUID() {
  const sUId = createUUID();
  setCookie('log_uid', sUId);
  return sUId;
}
